export function sanitizeCpf(cpf: string) {
  return String(Number(cpf.replace(/[^\d]/g, '')));
}
